import { Checkbox, FormControl, Stack, Typography } from "@mui/joy";
import { useLocalStorageState } from "ahooks";
import { memo } from "react";
import { useOrganizationAdminConfiguration } from "features/admin/contexts";
import { portalTypeStorageKeyName } from "features/dmp/constants";
import { PortalType } from "features/dmp/types";

const DmpFeatures = memo(() => {
  const [, setPortalType] = useLocalStorageState<string | undefined>(
    portalTypeStorageKeyName,
    { defaultValue: PortalType.DCR, listenStorageChange: true }
  );
  const { enableDmp, isEditorDisabled, updateOrganizationFlags } =
    useOrganizationAdminConfiguration();
  return (
    <Stack>
      <Typography level="title-md">DMP</Typography>
      <FormControl>
        <Stack>
          <Checkbox
            checked={enableDmp}
            disabled={isEditorDisabled}
            label="Enable DMP (BETA)"
            name="enableDmp"
            onChange={(event) => {
              updateOrganizationFlags(event);
              if (!event.target.checked) {
                setPortalType(PortalType.DCR);
              }
            }}
          />
        </Stack>
      </FormControl>
    </Stack>
  );
});
DmpFeatures.displayName = "DmpFeatures";

export default DmpFeatures;
